export default __webpack_public_path__ + "static/media/asset-7.3b902558.webp";